import axios, { AxiosError } from 'axios'
import { useAuthStore } from '@/stores/auth';
import { authService } from '@/services/auth';
import { setupLoadingInterceptor } from './utils/loading';
import { setupMessageInterceptor } from './utils/message';
import { setupResponseInterceptor } from './utils/response';
import type { CustomAxiosRequestConfig } from './utils/interface';
import { connectionId } from '@/utils/connection';

const http = axios.create({
  baseURL: import.meta.env.VITE_APP_URL,
  withCredentials: true
})

http.interceptors.request.use((config: CustomAxiosRequestConfig) => {

  const token = useAuthStore().token;

  if (token) {
    config.headers.Authorization = token
  }

  config.headers['X-Connection-Id'] = connectionId

  return config;
});


setupLoadingInterceptor(http);
setupMessageInterceptor(http);
setupResponseInterceptor(http)

// Resposta
http.interceptors.response.use(

  // Successo
  response => response,


  // Erro
  async (error: AxiosError) => {
    const config = error.config as CustomAxiosRequestConfig;

    if (error.status && error.response?.data) {
      const resError = (error.response.data as any)

      // Renova o token
      if (error.status == 401 && (resError.data == "invalid_token" || (resError instanceof Blob)) && !config._retry) {

        config._retry = true;
        try {
          const newToken = await authService.refreshToken();

          useAuthStore().token = newToken;
          config.headers.Authorization = newToken;
          return http(config);

        } catch (error) {
          useAuthStore().logout();
          return Promise.reject(error);
        }
      }
    }


    return Promise.reject(error);
  });

export default http